import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import WCheckbox from "@/components/form/w-checkbox.vue";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
import { AutoTranscriptStatus } from "@/models/ai/aiSubChapter.model";
import Loader from "@/components/loader/Loader.vue";
let AIQuizSubChapterSelect = class AIQuizSubChapterSelect extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speach", void 0);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "subchapterSelected", []);
    _defineProperty(this, "isDropdownOpened", false);
  }
  mounted() {
    this.subchapterSelected = this.value.map(subchapter => {
      return subchapter.id || 0;
    });
    this.toggleAllChaptersSelection(true);
  }
  get nbSelectedSubchaptersLabel() {
    return this.isAllSubchaptersSelected() ? this.$t('aiQuizGeneration.selectAIChapters.overallSpeachSelectedLabel') : this.$t('aiQuizGeneration.selectAIChapters.chapterSelected', this.subchapterSelected.length);
  }
  getAutoTranscriptStatus(subchapterId) {
    return this.getSubChapterById(subchapterId)?.autoTranscriptStatus.toString() || AutoTranscriptStatus.NONE.toString();
  }
  getSubChapterById(subchapterId) {
    for (const chapter of this.speach.chapters) {
      for (const subchapter of chapter.subchapters) {
        if (subchapter.id === subchapterId) {
          return subchapter;
        }
      }
    }
    return null;
  }
  isSubChapterSelectable(subchapterId) {
    const subchapter = this.getSubChapterById(subchapterId);
    if (subchapter) {
      return subchapter.autoTranscriptStatus === AutoTranscriptStatus.DONE || subchapter.autoTranscriptStatus === AutoTranscriptStatus.NA;
    }
    return false;
  }
  toggleAllChaptersSelection(state) {
    this.subchapterSelected = [];
    if (state) {
      this.speach.chapters?.forEach(chapter => {
        chapter?.subchapters?.forEach(subchapter => {
          const subchapterId = subchapter.id || 0;
          if (this.isSubChapterSelectable(subchapterId)) {
            this.subchapterSelected.push(subchapterId);
          }
        });
      });
    }
    this.emitSelectedSubchapters();
  }
  onDropdownToggle() {
    this.isDropdownOpened = !this.isDropdownOpened;
  }
  onSelectAllChapter(chapterId) {
    const chapter = this.speach.chapters.find(chapter => {
      return chapter.id === chapterId;
    });
    chapter?.subchapters.forEach(subchapter => {
      this.onSubChapterSelected(subchapter.id || 0);
    });
  }
  onSubChapterSelected(subchapterId) {
    if (this.isSubChapterSelectable(subchapterId)) {
      if (this.subchapterSelected.includes(subchapterId)) {
        this.subchapterSelected = this.subchapterSelected.filter(subchapterId2 => {
          return subchapterId2 !== subchapterId;
        });
      } else {
        this.subchapterSelected.push(subchapterId);
      }
    }
    this.emitSelectedSubchapters();
  }
  isAllSubchaptersSelected() {
    return this.subchapterSelected.length === this.getNbSelectableSubChapters();
  }
  getNbSelectableSubChapters() {
    return (this.speach.chapters ?? []).flatMap(c => c.subchapters ?? []).filter(sc => this.isSubChapterSelectable(sc.id ?? 0)).length;
  }
  emitSelectedSubchapters() {
    this.$emit('select', this.subchapterSelected);
  }
  forceRegenerateTranscript(subchapterId) {
    this.$emit('forceRegenerateTranscript', subchapterId);
  }
};
__decorate([Prop({
  required: true
})], AIQuizSubChapterSelect.prototype, "speach", void 0);
__decorate([Prop({
  default: []
})], AIQuizSubChapterSelect.prototype, "value", void 0);
__decorate([Prop({
  default: false
})], AIQuizSubChapterSelect.prototype, "disabled", void 0);
AIQuizSubChapterSelect = __decorate([Component({
  emits: ['select', 'forceRegenerateTranscript'],
  components: {
    Loader,
    Icon,
    WCheckbox,
    WToolTip
  }
})], AIQuizSubChapterSelect);
export default AIQuizSubChapterSelect;